import { render, staticRenderFns } from "./customerCareClosed.vue?vue&type=template&id=2abc2670&"
import script from "./customerCareClosed.vue?vue&type=script&lang=ts&"
export * from "./customerCareClosed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports